import React, { useState } from 'react';

interface CreateDocumentModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
}

export const CreateDocumentModal: React.FC<CreateDocumentModalProps> = ({
  visible,
  onCancel,
  onConfirm
}) => {
  const [documentName, setDocumentName] = useState('');

  if (!visible) return null;

  const handleConfirm = () => {
    if (documentName.trim()) {
      onConfirm(documentName.trim());
      setDocumentName('');
    }
  };

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const modalStyle: React.CSSProperties = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '400px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  };

  return (
    <div style={overlayStyle} onClick={onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 16px 0' }}>新建文档</h3>
        <input
          type="text"
          placeholder="请输入文档名称"
          value={documentName}
          onChange={(e) => setDocumentName(e.target.value)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            marginBottom: '16px'
          }}
          onKeyPress={(e) => e.key === 'Enter' && handleConfirm()}
          autoFocus
        />
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={onCancel}
            style={{
              marginRight: '8px',
              padding: '6px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            取消
          </button>
          <button
            onClick={handleConfirm}
            disabled={!documentName.trim()}
            style={{
              padding: '6px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#007bff',
              color: 'white',
              cursor: documentName.trim() ? 'pointer' : 'not-allowed',
              opacity: documentName.trim() ? 1 : 0.6
            }}
          >
            确定
          </button>
        </div>
      </div>
    </div>
  );
};